import React from 'react';
import { Table } from 'semantic-ui-react';
import localization from '../../../../locales/localization';

export default class ProcjenaHeaderCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.HeaderCell>{localization.artikl.kategorija}</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.common.kolicina}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">{localization.procjena.ocekivanaJedinicnaVrijednost}</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.common.vrijednost}
                </Table.HeaderCell>
            </React.Fragment>
        );
    }
}
